<template>
  <v-container fluid>
    <v-card class="shadowCard mt-6">
      <v-card-title class="headline">
        Panel de Validación de Ingresos
      </v-card-title>
      <v-card-text>

        <v-row>
          <v-col cols="12">
            <v-radio-group
              v-model="opNomina"
              row
            >
              <v-radio
                label="Subir Excel"
                :value="1"
              ></v-radio>
              <v-radio
                label="Validar ingresos"
                :value="2"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <!-- Subir PDF de nómina -->
        <v-row v-if="opNomina == 1">

          <v-col cols="10">
            <v-file-input
              v-model="excelIngresos"
              label="File input"
              hide-details
              filled
              dense
            ></v-file-input>
          </v-col>

          <v-col cols="2">
            <v-btn color="green" tile dark small @click="saveExcel( )">Guardar</v-btn>
          </v-col>

          <v-col cols="12">
            <v-data-table
              :headers="headerArchivos"
              :items=" archivosLeidos"
              class="elevation-0"
              dense
            >    
              <template v-slot:item.actions="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  color="blue"
                  @click="archivosLeidosDetalle = item.detalles, dialogPDFDetalles = true"
                >
                  mdi-pencil
                </v-icon>
              </template>

            </v-data-table>
          </v-col>
        </v-row>

        <v-row v-if="opNomina == 2">
          <v-col cols="12" md="6" class="d-flex align-center">
            <v-autocomplete
              filled 
              dense
              clearable
              v-model="archivoSeleccionado"
              :items="archivosLeidos"
              label="Selecciona el archivo"
              item-text="excelname"
              single-line
              item-value="idexcel_ingresos"
              class="mt-4"
              hide-details
              return-object
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="6" class="d-flex align-center">
            <v-btn
              color="success"
              outlined
              :disabled="!processedResults.length"
              @click="exportResults"
            >
              <v-icon left>mdi-download</v-icon>
              Exportar Resultados
            </v-btn>
          </v-col>

          <v-col cols="12" md="6" class="d-flex align-center">
            <v-btn
              color="success"
              outlined
              :disabled="!processedResults.length"
              @click="subirDetalles"
            >
              <v-icon left>mdi-download</v-icon>
              Subir Detalles
            </v-btn>
          </v-col>


        </v-row>

        <!-- Resumen estadístico -->
        <v-row v-if="opNomina == 2 ">
          <v-col cols="12" sm="2">
            <v-card class="shadowCard outlined text-center" color="#e1e1e0">
              <v-card-title class="font-weight-bold justify-center subtitle-1 black--text">
                Total Registros
              </v-card-title>
              <v-card-text>
                <span class="display-1 font-weight-bold black--text">{{ processedResults.length }}</span>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="2">
            <v-card class="shadowCard outlined text-center" color="#d0f48d">
              <v-card-title class="font-weight-bold justify-center subtitle-1 green--text">
                Ingresos
              </v-card-title>
              <v-card-text>
                <span class="display-1 font-weight-bold text-primary green--text">
                  {{ processedResults.filter(item => item.tipoTransaccion === 'Ingreso').length }}
                </span>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="2">
            <v-card class="shadowCard outlined text-center" color="#f4d08d">
              <v-card-title class="font-weight-bold justify-center subtitle-1 orange--text">
                Egresos
              </v-card-title>
              <v-card-text>
                <span class="display-1 font-weight-bold text-warning orange--text">
                  {{ processedResults.filter(item => item.tipoTransaccion === 'Egreso').length }}
                </span>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="3">
            <v-card class="shadowCard outlined text-center" color="#aed4ff">
              <v-card-title class="font-weight-bold justify-center subtitle-1 blue--text">
                Con Match
              </v-card-title>
              <v-card-text>
                <span class="display-1 font-weight-bold blue--text">
                  {{ processedResults.filter(item => item.status === 'Con Match').length }}
                </span>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="3">
            <v-card class="shadowCard outlined text-center" color="#fe9393">
              <v-card-title class="font-weight-bold justify-center subtitle-1 red--text">
                Sin Match
              </v-card-title>
              <v-card-text>
                <span class="display-1 font-weight-bold red--text">
                  {{ processedResults.filter(item => item.status === 'Sin Match' && item.tipoTransaccion !== 'Egreso').length }}
                </span>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row justify="end" v-if="opNomina == 2 ">

          <v-col cols="12" class="text-h6 mt-6 black--text">
            Resultados de la validación
          </v-col>

          <v-col cols="12">
            <v-row>
              <v-col cols="12" sm="4" md="3">
                <v-select
                  v-model="tipoTransaccionFilter"
                  :items="tipoTransaccionOptions"
                  label="Tipo de Transacción"
                  hide-details
                  dense
                  filled
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-select
                  v-model="statusFilter"
                  :items="statusOptions"
                  label="Aprobación"
                  hide-details
                  dense
                  filled
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-select
                  v-model="searchStatusFilter"
                  :items="searchStatusOptions"
                  label="Match"
                  hide-details
                  dense
                  filled
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-select
                  v-model="bancoFilter"
                  :items="bancoOptions"
                  label="Banco"
                  hide-details
                  dense
                  filled
                ></v-select>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="6">
            <v-btn
              color="success"
              outlined
              @click="validarMultiple( )"
            >
              <v-icon left>mdi-check</v-icon>
              Validación Multiple
            </v-btn>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
              filled
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            
            <v-data-table
              :headers="headers"
              :items="filteredResults"
              :search="search"
              :loading="loading"
              :items-per-page="10"
              :footer-props="{
                'items-per-page-options': [10, 50, 100, -1],
                'items-per-page-text': 'Registros por página:',
                'items-per-page-all-text': 'Todos'
              }"
              class="elevation-0"
            >

              <template v-slot:item.banco="{ item }">
                <v-chip
                  small
                  :color="getBancoColor(item.banco)"
                  text-color="white"
                  label
                >
                  {{ getBancoLabel(item.banco) }}
                </v-chip>
              </template>

              <template v-slot:item.aceptado="{ item }">
                <v-chip
                  v-if="item.aceptado === 1"
                  color="success"
                  small
                  label
                  outlined
                >
                  Aceptado
                </v-chip>
                <v-chip
                  v-else-if="item.aceptado === 2"
                  color="error"
                  small
                  label
                  outlined
                >
                  Rechazado
                </v-chip>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn
                  small
                  color="success"
                  icon
                  @click="updateStatus(item, 1)"
                  :disabled="item.aceptado === 1"
                  class="mr-1"
                >
                  <v-icon small>mdi-check</v-icon>
                </v-btn>
                <v-btn
                  small
                  color="error"
                  icon
                  @click="updateStatus(item, 2)"
                  :disabled="item.aceptado === 2"
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </template>

              <template v-slot:item.alumno="{ item }">
                <span v-if="item.dbData && item.dbData.alumno" class="font-weight-medium">{{ item.dbData.alumno }}</span>
              </template>

              <template v-slot:item.dbData="{ item }">
                <v-btn
                  small
                  text
                  color="primary"
                  :color="item.dbData && item.dbData.matchInfo && item.dbData.matchInfo.diferencia_monto ? 'error' : 'primary'"
                  @click="showDetails(item)"
                >
                  Ver detalles
                  <span v-if="item.allMatches && item.allMatches.length > 1" class="ml-1">
                    ({{ item.allMatches.length }})
                  </span>
                </v-btn>
                <!-- <v-btn
                  v-else
                  small
                  outlined
                  color="primary"
                  @click="showManualSearch(item)"
                >
                  Buscar en BD
                </v-btn> -->
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>


    <!-- Diálogo para mostrar detalles -->
    <v-dialog v-model="detailDialog" max-width="700">
      <v-card>
        <v-card-title class="headline">
          Detalles del registro
          <v-spacer></v-spacer>
          <v-btn icon @click="detailDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle v-if="selectedItem && selectedItem.allMatches && selectedItem.allMatches.length > 1" class="py-0">
          <div class="d-flex align-center">
            <span class="text-subtitle-1 font-weight-bold">Coincidencia {{ selectedItem.currentMatchIndex + 1 }} de {{ selectedItem.allMatches.length }}</span>
            <v-spacer></v-spacer>
            <v-btn
              icon
              color="primary"
              :disabled="selectedItem.currentMatchIndex === 0"
              @click="navigateMatch(-1)"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn
              icon
              color="primary"
              :disabled="selectedItem.currentMatchIndex === selectedItem.allMatches.length - 1"
              @click="navigateMatch(1)"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
            <v-btn
              small
              color="success"
              @click="selectMatch"
              class="ml-2"
            >
              <v-icon small left>mdi-check</v-icon>
              Seleccionar esta coincidencia
            </v-btn>
          </div>
        </v-card-subtitle>
        <v-card-text v-if="selectedItem">
          <v-row>
            <v-col cols="12" md="6">
              <h3 class="subtitle-1 font-weight-bold mb-2">Datos del Excel</h3>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Fecha</v-list-item-subtitle>
                  <v-list-item-title>{{ selectedItem.fecha }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Banco</v-list-item-subtitle>
                  <v-list-item-title>
                    <v-chip
                      x-small
                      :color="getBancoColor(selectedItem.banco)"
                      text-color="white"
                    >
                      {{ getBancoLabel(selectedItem.banco) }}
                    </v-chip>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Concepto/Referencia</v-list-item-subtitle>
                  <v-list-item-title class="text-wrap">{{ selectedItem.concepto }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Monto</v-list-item-subtitle>
                  <v-list-item-title>{{ selectedItem.monto }}</v-list-item-title>
                  <v-list-item v-if="selectedItem.dbData && selectedItem.dbData.matchInfo && selectedItem.dbData.matchInfo.diferencia_monto">
                    <v-list-item-content>
                      <v-list-item-subtitle class="font-weight-bold error--text">¡Diferencia en montos!</v-list-item-subtitle>
                      <v-list-item-title>
                        Excel: {{ selectedItem.dbData.matchInfo.diferencia_monto.monto_excel.toFixed(2) }}
                        <v-icon small color="error">mdi-arrow-left-right</v-icon>
                        BD: {{ selectedItem.dbData.matchInfo.diferencia_monto.monto_bd.toFixed(2) }}
                      </v-list-item-title>
                      <v-list-item-title class="error--text">
                        Diferencia: {{ selectedItem.dbData.matchInfo.diferencia_monto.diferencia.toFixed(2) }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item v-if="selectedItem.dbData && selectedItem.dbData.matchInfo">
                <v-list-item-content>
                  <v-list-item-subtitle class="font-weight-bold">Información de coincidencia</v-list-item-subtitle>
                  <v-list-item-title class="text-wrap">
                    Referencia extraída: {{ selectedItem.dbData.matchInfo.referencia_extraida }}
                  </v-list-item-title>
                  <v-list-item-title>
                    Campo de coincidencia:
                    <v-chip x-small color="primary" text-color="white">
                      {{ selectedItem.dbData.matchInfo.tipo_coincidencia === 'clave_rastreo' ? 'Clave de Rastreo' :
                         selectedItem.dbData.matchInfo.tipo_coincidencia === 'folio_operacion' ? 'Folio de Operación' :
                         'Texto Completo' }}
                    </v-chip>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item v-if="selectedItem.detailedInfo">
                <v-list-item-content>
                  <v-list-item-subtitle class="font-weight-bold mb-2">Información Extraída</v-list-item-subtitle>

                  <div v-if="selectedItem.detailedInfo.numericalGroups && selectedItem.detailedInfo.numericalGroups.length > 0" class="mb-2">
                    <span class="font-weight-medium">Referencias Numéricas:</span>
                    <div v-for="(num, index) in selectedItem.detailedInfo.numericalGroups" :key="'num-'+index" class="ml-2">
                      <span class="text-wrap">{{ num }}</span>
                    </div>
                  </div>

                  <div v-if="selectedItem.detailedInfo.textGroups && selectedItem.detailedInfo.textGroups.length > 0" class="mb-2">
                    <span class="font-weight-medium">Texto Extraído:</span>
                    <div v-for="(text, index) in selectedItem.detailedInfo.textGroups" :key="'text-'+index" class="ml-2">
                      <span class="text-wrap">{{ text }}</span>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" md="6">
              <h3 class="subtitle-1 font-weight-bold mb-2">Datos de la Base</h3>
              <template v-if="selectedItem.dbData">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>ID Ingreso</v-list-item-subtitle>
                    <v-list-item-title>{{ selectedItem.dbData.id_ingreso }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Alumno</v-list-item-subtitle>
                    <v-list-item-title>{{ selectedItem.dbData.alumno }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Monto Pagado</v-list-item-subtitle>
                    <v-list-item-title>{{ selectedItem.dbData.monto_pagado }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Fecha de Pago</v-list-item-subtitle>
                    <v-list-item-title>{{ selectedItem.dbData.fecha_pago }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Comprobante</v-list-item-subtitle>
                    <v-list-item-title v-if="selectedItem.dbData.url_foto">
                      <v-img
                        :src="selectedItem.dbData && selectedItem.dbData.url_foto ? getFullImageUrl(selectedItem.dbData.url_foto) : ''"
                        max-height="150"
                        max-width="300"
                        contain
                        class="cursor-pointer"
                        @click="openImageDialog(selectedItem.dbData.url_foto)"
                      ></v-img>
                    </v-list-item-title>
                    <v-list-item-title v-else>
                      <v-chip small color="warning" text-color="white">Sin comprobante</v-chip>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Clave Rastreo</v-list-item-subtitle>
                    <v-list-item-title>{{ selectedItem.dbData.aut_clave_rastreo }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Folio Operación</v-list-item-subtitle>
                    <v-list-item-title>{{ selectedItem.dbData.folio_operacion }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item v-if="selectedItem.dbData && selectedItem.dbData.texto_completo">
                  <v-list-item-content>
                    <v-list-item-subtitle>Texto Completo</v-list-item-subtitle>
                    <v-list-item-title class="text-wrap">{{ selectedItem.dbData.texto_completo }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <v-alert v-else type="error" dense>No se encontró coincidencia en la base de datos</v-alert>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- Panel de búsqueda en base de datos -->
        <v-divider></v-divider>
        <v-expansion-panels flat>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div class="d-flex align-center">
                <v-icon left color="primary">mdi-database-search</v-icon>
                <span>Buscar en base de datos</span>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-alert
                type="info"
                text
                dense
                class="mb-3"
              >
                Para encontrar coincidencias en la base de datos, seleccione y copie diferentes partes del texto del concepto e intente buscarlas.
              </v-alert>
              <v-row>
                <v-col cols="12">
                  <v-form @submit.prevent="searchRecordsFromDetail">
                    <v-row>
                      <v-col cols="12" md="8">
                        <v-text-field
                          v-model="detailSearch.referencia"
                          label="Referencia a buscar"
                          outlined
                          dense
                          placeholder="Ingrese la referencia o texto para buscar en la base de datos"
                          clearable
                          hint="Pruebe copiando diferentes extractos del concepto para encontrar coincidencias"
                          persistent-hint
                        >
                          <template v-slot:append-outer>
                            <v-tooltip bottom max-width="300">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="primary"
                                  small
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-help-circle-outline
                                </v-icon>
                              </template>
                              <span>
                                Sugerencias para búsqueda efectiva:<br>
                                • Copie números de referencia del concepto<br>
                                • Pruebe con nombres o apellidos visibles<br>
                                • Para búsquedas más específicas, use claves de rastreo o folios<br>
                                • Intente con diferentes combinaciones si no encuentra resultados
                              </span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="4" class="d-flex align-center">
                        <v-btn
                          color="primary"
                          :loading="detailSearchLoading"
                          @click="searchRecordsFromDetail"
                          class="ml-2"
                        >
                          <v-icon left>mdi-magnify</v-icon>
                          Buscar
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>

              <!-- Resultados de búsqueda -->
              <v-alert
                v-if="detailSearchResults.length === 0 && detailSearchPerformed"
                type="info"
                dense
                class="mt-4"
              >
                No se encontraron registros con los criterios especificados
              </v-alert>

              <v-data-table
                v-if="detailSearchResults.length > 0"
                :headers="detailSearchHeaders"
                :items="detailSearchResults"
                :loading="detailSearchLoading"
                dense
                :items-per-page="3"
                class="mt-4"
              >
                <template v-slot:item.monto_pagado="{ item }">
                  {{ item.monto_pagado }}
                </template>
                <template v-slot:item.fecha_pago="{ item }">
                  {{ new Date(item.fecha_pago).toLocaleDateString() }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn
                    x-small
                    color="success"
                    @click="assignDetailResult(item)"
                  >
                    Asignar
                  </v-btn>
                </template>
              </v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="detailDialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="imageDialog" max-width="900">
      <v-card>
        <v-card-title class="headline">
          Comprobante de Pago
          <v-spacer></v-spacer>
          <v-btn icon @click="imageDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-img
            :src="imageDialogUrl"
            max-height="600"
            contain
          ></v-img>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="imageDialog = false">Cerrar</v-btn>
          <v-btn color="secondary" text :href="imageDialogUrl" target="_blank">Ver Original</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para búsqueda manual -->
    <v-dialog v-model="manualSearchDialog" max-width="800">
      <v-card>
        <v-card-title class="headline">
          Búsqueda manual en base de datos
          <v-spacer></v-spacer>
          <v-btn icon @click="manualSearchDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <h3 class="subtitle-1 font-weight-bold mb-4">Datos del Excel</h3>
              <v-list dense>
                <v-list-item v-if="selectedItem">
                  <v-list-item-content>
                    <v-list-item-subtitle class="mb-1">Fecha</v-list-item-subtitle>
                    <v-list-item-title>{{ selectedItem.fecha }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="my-2"></v-divider>
                <v-list-item v-if="selectedItem">
                  <v-list-item-content>
                    <v-list-item-subtitle class="mb-1">Concepto/Referencia</v-list-item-subtitle>
                    <v-list-item-title style="white-space: normal; word-break: break-word;">
                      {{ selectedItem.concepto }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="my-2"></v-divider>
                <v-list-item v-if="selectedItem">
                  <v-list-item-content>
                    <v-list-item-subtitle class="mb-1">Monto</v-list-item-subtitle>
                    <v-list-item-title>{{ selectedItem.monto }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" md="6">
              <h3 class="subtitle-1 font-weight-bold mb-4">Buscar registro</h3>
              <v-form>
                <v-text-field
                  v-model="manualSearch.id"
                  label="ID Ingreso"
                  type="number"
                  outlined
                  dense
                  class="mb-4"
                ></v-text-field>
                <v-text-field
                  v-model="manualSearch.alumno"
                  label="Nombre del alumno"
                  outlined
                  dense
                  class="mb-4"
                ></v-text-field>
                <v-text-field
                  v-model="manualSearch.monto"
                  label="Monto (aproximado)"
                  type="number"
                  outlined
                  dense
                  class="mb-4"
                ></v-text-field>
                <v-text-field
                  v-model="manualSearch.referencia"
                  label="Referencia o folio"
                  outlined
                  dense
                  class="mb-4"
                ></v-text-field>
                <v-btn
                  color="primary"
                  block
                  class="mt-4"
                  :loading="manualSearchLoading"
                  @click="searchRecords"
                  elevation="2"
                >
                  <v-icon left>mdi-magnify</v-icon>
                  BUSCAR
                </v-btn>
              </v-form>
            </v-col>
          </v-row>

          <!-- Resultados de búsqueda -->
          <v-alert
            v-if="manualSearchResults.length === 0 && manualSearchPerformed"
            type="info"
            dense
            class="mt-6"
          >
            No se encontraron registros con los criterios de búsqueda especificados
          </v-alert>

          <v-data-table
            v-if="manualSearchResults.length > 0"
            :headers="manualSearchHeaders"
            :items="manualSearchResults"
            :loading="manualSearchLoading"
            item-key="id_ingreso"
            class="mt-6"
            dense
            :items-per-page="5"
          >
            <template v-slot:item.monto_pagado="{ item }">
              {{ item.monto_pagado }}
            </template>
            <template v-slot:item.fecha_pago="{ item }">
              {{ new Date(item.fecha_pago).toLocaleDateString() }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                small
                color="success"
                @click="assignDbRecord(item)"
              >
                Asignar
              </v-btn>
            </template>
          </v-data-table>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="manualSearchDialog = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar para notificaciones -->
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Dialog para ver los movimientos dentro del sistema -->
    <v-dialog
      v-model="dialogPDFDetalles"
      max-width="800"
    >
      <v-card>
        <v-card-title primary-title >
          Detalles de la nomina
          <v-spacer></v-spacer>
        </v-card-title>
        
        <v-card-text>
          <v-data-table
            :headers="headerArchivosDetalle"
            :items=" archivosLeidosDetalle"
            class="elevation-0"
            dense
          >                 
          </v-data-table>
        </v-card-text>
        
        <v-btn 
          color="transparent elevation-0"
          x-small
          absolute
          top
          right
          fab
          class="mt-5 mr-0"
          @click="dialogPDFDetalles = false"
         ><v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>

    <!-- Validación multiple -->
    <v-dialog v-model="dialgoValidaMultiple" max-width="700">

      <v-card>
        <v-card-title primary-title>
          Validación de datos multiple
        </v-card-title>
        
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="4" md="3">
              <v-select
                v-model="bancoFilterMultiple"
                :items="bancoOptions"
                label="Banco"
                hide-details
                dense
                filled
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>        
      </v-card>


      <v-card v-for="( rowDetalle , i ) in filterDataMultiple" :key="i">
        <v-card-title class="headline">
          Detalles del registro
          <v-spacer></v-spacer>
          <v-btn icon @click="dialgoValidaMultiple = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-subtitle v-if="rowDetalle && rowDetalle.allMatches && rowDetalle.allMatches.length > 1" class="py-0">
          <div class="d-flex align-center">
            <span class="text-subtitle-1 font-weight-bold">Coincidencia {{ rowDetalle.currentMatchIndex + 1 }} de {{ rowDetalle.allMatches.length }}</span>
            <v-spacer></v-spacer>
            <v-btn
              icon
              color="primary"
              :disabled="rowDetalle.currentMatchIndex === 0"
              @click="navigateMatch(-1)"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn
              icon
              color="primary"
              :disabled="rowDetalle.currentMatchIndex === rowDetalle.allMatches.length - 1"
              @click="navigateMatch(1)"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
            <v-btn
              small
              color="success"
              @click="selectMatch"
              class="ml-2"
            >
              <v-icon small left>mdi-check</v-icon>
              Seleccionar esta coincidencia
            </v-btn>
          </div>
        </v-card-subtitle>
        <v-card-text v-if="rowDetalle">
          <v-row>
            <v-col cols="12" md="6">
              <h3 class="subtitle-1 font-weight-bold mb-2">Datos del Excel</h3>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Fecha</v-list-item-subtitle>
                  <v-list-item-title>{{ rowDetalle.fecha }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Banco</v-list-item-subtitle>
                  <v-list-item-title>
                    <v-chip
                      x-small
                      :color="getBancoColor(rowDetalle.banco)"
                      text-color="white"
                    >
                      {{ getBancoLabel(rowDetalle.banco) }}
                    </v-chip>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Concepto/Referencia</v-list-item-subtitle>
                  <v-list-item-title class="text-wrap">{{ rowDetalle.concepto }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Monto</v-list-item-subtitle>
                  <v-list-item-title>{{ rowDetalle.monto }}</v-list-item-title>
                  <v-list-item v-if="rowDetalle.dbData && rowDetalle.dbData.matchInfo && rowDetalle.dbData.matchInfo.diferencia_monto">
                    <v-list-item-content>
                      <v-list-item-subtitle class="font-weight-bold error--text">¡Diferencia en montos!</v-list-item-subtitle>
                      <v-list-item-title>
                        Excel: {{ rowDetalle.dbData.matchInfo.diferencia_monto.monto_excel.toFixed(2) }}
                        <v-icon small color="error">mdi-arrow-left-right</v-icon>
                        BD: {{ rowDetalle.dbData.matchInfo.diferencia_monto.monto_bd.toFixed(2) }}
                      </v-list-item-title>
                      <v-list-item-title class="error--text">
                        Diferencia: {{ rowDetalle.dbData.matchInfo.diferencia_monto.diferencia.toFixed(2) }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item v-if="rowDetalle.dbData && rowDetalle.dbData.matchInfo">
                <v-list-item-content>
                  <v-list-item-subtitle class="font-weight-bold">Información de coincidencia</v-list-item-subtitle>
                  <v-list-item-title class="text-wrap">
                    Referencia extraída: {{ rowDetalle.dbData.matchInfo.referencia_extraida }}
                  </v-list-item-title>
                  <v-list-item-title>
                    Campo de coincidencia:
                    <v-chip x-small color="primary" text-color="white">
                      {{ rowDetalle.dbData.matchInfo.tipo_coincidencia === 'clave_rastreo' ? 'Clave de Rastreo' :
                         rowDetalle.dbData.matchInfo.tipo_coincidencia === 'folio_operacion' ? 'Folio de Operación' :
                         'Texto Completo' }}
                    </v-chip>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item v-if="rowDetalle.detailedInfo">
                <v-list-item-content>
                  <v-list-item-subtitle class="font-weight-bold mb-2">Información Extraída</v-list-item-subtitle>

                  <div v-if="rowDetalle.detailedInfo.numericalGroups && rowDetalle.detailedInfo.numericalGroups.length > 0" class="mb-2">
                    <span class="font-weight-medium">Referencias Numéricas:</span>
                    <div v-for="(num, index) in rowDetalle.detailedInfo.numericalGroups" :key="'num-'+index" class="ml-2">
                      <span class="text-wrap">{{ num }}</span>
                    </div>
                  </div>

                  <div v-if="rowDetalle.detailedInfo.textGroups && rowDetalle.detailedInfo.textGroups.length > 0" class="mb-2">
                    <span class="font-weight-medium">Texto Extraído:</span>
                    <div v-for="(text, index) in rowDetalle.detailedInfo.textGroups" :key="'text-'+index" class="ml-2">
                      <span class="text-wrap">{{ text }}</span>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>

              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle class="font-weight-bold mb-2">Validación</v-list-item-subtitle>

                  <div class="mb-2">
                    <v-btn
                      small
                      color="success"
                      @click="updateStatus(rowDetalle, 1)"
                      :disabled="rowDetalle.aceptado === 1"
                      outlined
                      class="mr-1"
                    >
                      <v-icon small>mdi-check</v-icon>
                      Validar
                    </v-btn>
                    <v-btn
                      small
                      color="error"
                      @click="updateStatus(rowDetalle, 2)"
                      :disabled="rowDetalle.aceptado === 2"
                      outlined
                    >
                      <v-icon small>mdi-close</v-icon>
                      Rechazar
                    </v-btn>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>




            </v-col>
            <v-col cols="12" md="6">
              <h3 class="subtitle-1 font-weight-bold mb-2">Datos de la Base</h3>
              <template v-if="rowDetalle.dbData">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>ID Ingreso</v-list-item-subtitle>
                    <v-list-item-title>{{ rowDetalle.dbData.id_ingreso }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Alumno</v-list-item-subtitle>
                    <v-list-item-title>{{ rowDetalle.dbData.alumno }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Monto Pagado</v-list-item-subtitle>
                    <v-list-item-title>{{ rowDetalle.dbData.monto_pagado }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Fecha de Pago</v-list-item-subtitle>
                    <v-list-item-title>{{ rowDetalle.dbData.fecha_pago }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Comprobante</v-list-item-subtitle>
                    <v-list-item-title v-if="rowDetalle.dbData.url_foto">
                      <v-img
                        :src="rowDetalle.dbData && rowDetalle.dbData.url_foto ? getFullImageUrl(rowDetalle.dbData.url_foto) : ''"
                        max-height="150"
                        max-width="300"
                        contain
                        class="cursor-pointer"
                        @click="openImageDialog(rowDetalle.dbData.url_foto)"
                      ></v-img>
                    </v-list-item-title>
                    <v-list-item-title v-else>
                      <v-chip small color="warning" text-color="white">Sin comprobante</v-chip>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Clave Rastreo</v-list-item-subtitle>
                    <v-list-item-title>{{ rowDetalle.dbData.aut_clave_rastreo }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Folio Operación</v-list-item-subtitle>
                    <v-list-item-title>{{ rowDetalle.dbData.folio_operacion }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item v-if="rowDetalle.dbData && rowDetalle.dbData.texto_completo">
                  <v-list-item-content>
                    <v-list-item-subtitle>Texto Completo</v-list-item-subtitle>
                    <v-list-item-title class="text-wrap">{{ rowDetalle.dbData.texto_completo }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <v-alert v-else type="error" dense>No se encontró coincidencia en la base de datos</v-alert>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <!-- Panel de búsqueda en base de datos -->
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialgoValidaMultiple = false">Cerrar</v-btn>
      </v-card-actions>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />

  </v-container>
</template>

<script>
import axios from 'axios';
import * as XLSX from 'xlsx';

// Componentes
import Alerta         from "@/components/alertas/Alerta.vue";
import carga          from "@/components/alertas/carga.vue";
import validarErrores from "@/mixins/validarErrores";


export default {
  name: 'ValidationPanel',
  data() {
    return {

      // Alertas
      parametros: {
        dialogError: false,
        mensaje: "",
        color: "",
      },

      respuestaAlerta: false,
      loader: true,
      cargar: false,

      // Nuevos filtros
      bancoFilter: 'Todos',
      bancoFilterMultiple: 'Todos',
      searchStatusFilter: 'Todos',

      // Opciones para los nuevos filtros
      bancoOptions: ['Todos', 'BBVA', 'BanRegio', 'HSBC'],
      searchStatusOptions: ['Todos', 'Con match', 'Sin Match'],
      tipoTransaccionFilter: 'Todos',
      tipoTransaccionOptions: ['Todos', 'Ingreso', 'Egreso'],

      currentMatchIndex: 0,

      excelFile: null,
      loading: false,
      dbData: [],
      processedResults: [],
      search: '',
      statusFilter: 'Todos',
      statusOptions: ['Todos', 'Aceptado', 'Rechazado', 'Pendiente'],
      headers: [
        { text: 'Fecha', value: 'fecha', width: '10%' },
        { text: 'Concepto/Referencia', value: 'concepto', width: '20%' },
        { text: 'Banco', value: 'banco', width: '8%' },  // Nueva columna para el banco
        { text: 'Monto', value: 'monto', width: '8%' },
        { text: 'Alumno', value: 'alumno', width: '15%' },
        { text: 'Estado', value: 'status', width: '8%' },
        { text: 'Aprobación', value: 'aceptado', width: '8%' },
        { text: 'Detalles BD', value: 'dbData', width: '10%' },
        { text: 'Acciones', value: 'actions', width: '8%', sortable: false },
      ],
      detailDialog: false,
      selectedItem: null,

      imageDialog: false,
      imageDialogUrl: null,
      // Para búsqueda manual
      manualSearchDialog: false,
      manualSearchLoading: false,
      manualSearchPerformed: false,
      manualSearch: {
        id: '',
        alumno: '',
        monto: '',
        referencia: ''
      },
      manualSearchResults: [],
      manualSearchHeaders: [
        { text: 'ID', value: 'id_ingreso', width: '10%' },
        { text: 'Alumno', value: 'alumno', width: '30%' },
        { text: 'Monto', value: 'monto_pagado', width: '15%' },
        { text: 'Fecha', value: 'fecha_pago', width: '15%' },
        { text: 'Referencia', value: 'aut_clave_rastreo', width: '15%' },
        { text: 'Acciones', value: 'actions', width: '15%', sortable: false }
      ],
      snackbar: {
        show: false,
        text: '',
        color: '',
        timeout: 4000
      },

      // Búsqueda desde detalles
      detailSearch: {
        referencia: '',
      },
      detailSearchResults: [],
      detailSearchLoading: false,
      detailSearchPerformed: false,
      detailSearchHeaders: [
        { text: 'ID', value: 'id_ingreso', width: '10%' },
        { text: 'Alumno', value: 'alumno', width: '35%' },
        { text: 'Monto', value: 'monto_pagado', width: '15%' },
        { text: 'Fecha', value: 'fecha_pago', width: '15%' },
        { text: 'Referencia', value: 'aut_clave_rastreo', width: '15%' },
        { text: 'Acciones', value: 'actions', width: '10%', sortable: false }
      ],

      // LECTURA DE ARCHIVO
      opNomina: 1,
      headerArchivos:[
        { text: "ID"          , value: "idexcel_ingresos", sortable: false },
        { text: "Nombre"      , value: "excelname"            },
        { text: "MD5"         , value: "excelmd5"             },
        { text: "Fecha"       , value: "fecha_creacion"     },
        { text: "Actions"     , value: "actions"            },
      ],
      archivosLeidos:[],
      headerArchivosDetalle:[
        { text: "fecha"     , value: "fecha"           },
        { text: "concepto"  , value: "concepto"        },
        { text: "pago"      , value: "pago"            },
        { text: "banco"     , value: "banco"           },
      ],
      archivosLeidosDetalle:[],
      dialogPDFDetalles: false,

      partidasNomina:[],
      excelIngresos: null,
      archivoSeleccionado: null,
      dialgoValidaMultiple: false,
      dataMultiple: []
    };
  },

  components: {
    Alerta,
    carga,
  },

  watch:{

    archivoSeleccionado ( value ){

      if( value ){
        this.archivosLeidosDetalle = value.detalles
        this.processExcel( )

      }
    }

  },


  created( ) {

    this.getTablaIngresos( )
  
  },

  mixins: [validarErrores],

  computed: {
    filteredResults() {
      let results = this.processedResults;

      // Filtrar por estado de aprobación
      if (this.statusFilter === 'Aceptado') {
        results = results.filter(item => item.aceptado === 1);
      } else if (this.statusFilter === 'Rechazado') {
        results = results.filter(item => item.aceptado === 2);
      } else if (this.statusFilter === 'Pendiente') {
        results = results.filter(item => item.aceptado === null);
      }

      // Filtrar por estado de búsqueda
      if (this.searchStatusFilter !== 'Todos') {
        results = results.filter(item => item.status === this.searchStatusFilter);
      }

      // Filtrar por tipo de transacción (nuevo filtro)
      if (this.tipoTransaccionFilter !== 'Todos') {
        results = results.filter(item => item.tipoTransaccion === this.tipoTransaccionFilter);
      }

      // Filtrar por banco
      if (this.bancoFilter !== 'Todos') {
        results = results.filter(item => {
          const bancoLabel = this.getBancoLabel(item.banco);
          return bancoLabel === this.bancoFilter;
        });
      }

      return results;
    },

    filterDataMultiple( ){
      let results = this.dataMultiple;

      // // Filtrar por estado de aprobación
      // if (this.statusFilter === 'Aceptado') {
      //   results = results.filter(item => item.aceptado === 1);
      // } else if (this.statusFilter === 'Rechazado') {
      //   results = results.filter(item => item.aceptado === 2);
      // } else if (this.statusFilter === 'Pendiente') {
      //   results = results.filter(item => item.aceptado === null);
      // }

      // // Filtrar por estado de búsqueda
      // if (this.searchStatusFilter !== 'Todos') {
      //   results = results.filter(item => item.status === this.searchStatusFilter);
      // }

      // // Filtrar por tipo de transacción (nuevo filtro)
      // if (this.tipoTransaccionFilter !== 'Todos') {
      //   results = results.filter(item => item.tipoTransaccion === this.tipoTransaccionFilter);
      // }

      // Filtrar por banco
      if (this.bancoFilterMultiple !== 'Todos') {
        results = results.filter(item => {
          const bancoLabel = this.getBancoLabel(item.banco);
          return bancoLabel === this.bancoFilterMultiple;
        });
      }

      return results;
    }
  },

  methods: {
    async fetchDbData() {
      try {
        const response = await axios.get('/ingresos.rastreo.all');
        this.dbData = response.data;

        return response.data;
      } catch (error) {
        console.error('Error al obtener datos de la API:', error);
        this.showSnackbar('Error al obtener datos de la base de datos', 'error');
        return [];
      }
    },

    async subirDetalles( ){

      let encontrados = this.processedResults.filter(item => item.status === 'Con match');

      let datosEncontrados = encontrados.map((registro => { return registro.dbData }))

      try {
        // Mostrar indicador de carga (opcional)
        this.loading = true;

        // Llamar a la API
        const response = await axios.post(`/ingresos.encontrado`, datosEncontrados );

        this.validarSuccess('Datos guardados correctamente')

      } catch (error) {
        console.error('Error al actualizar el estado:', error);
        this.showSnackbar('Error al actualizar el estado del registro', 'error');
      } finally {
        this.loading = false;
      }

    },

    resetData() {
      this.processedResults = [];
      this.dbData = [];
    },

    openImageDialog(imageUrl) {
      const fullUrl = this.getFullImageUrl(imageUrl);
      this.imageDialogUrl = fullUrl;
      this.imageDialog = true;
    },

    async processExcel() {
      // if (!this.excelFile) {
      //   this.showSnackbar('Por favor seleccione un archivo Excel', 'warning');
      //   return;
      // }

      this.loading = true;

      try {
        // Obtener datos de la BD
        const dbData = await this.fetchDbData();

        // Si no hay datos de la BD, mostrar advertencia
        if (!dbData || !dbData.length) {
          console.warn('¡ATENCIÓN! No se recibieron datos de la API');
          this.showSnackbar('No se obtuvieron datos de la base de datos', 'warning');
        }

        // Procesar el archivo Excel
        const reader = new FileReader();

        // reader.onload = (e) => {
        //   try {
        //     const data = new Uint8Array(e.target.result);
        //     const workbook = XLSX.read(data, { type: 'array', cellDates: true });

        //     // Asumimos que la primera hoja contiene los datos
        //     const firstSheetName = workbook.SheetNames[0];
        //     const worksheet = workbook.Sheets[firstSheetName];

        //     // Convertir a JSON
        //     const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, raw: false });

        //     // Si hay encabezados, filtrarlos (primera fila)
        //     const rows = jsonData.length > 1 ? jsonData.slice(1) : jsonData;

            // Procesar y validar cada fila
        this.processRows(this.archivosLeidosDetalle, dbData);

          //   this.showSnackbar(`Se procesaron ${this.processedResults.length} registros`, 'success');
          // } catch (error) {
          //   console.error('Error al procesar el Excel:', error);
          //   this.showSnackbar('Error al procesar el archivo Excel', 'error');
          // } finally {
          //   this.loading = false;
          // }
        // };

        // reader.onerror = () => {
        //   this.showSnackbar('Error al leer el archivo', 'error');
        //   this.loading = false;
        // };

        // reader.readAsArrayBuffer(this.excelFile);

        this.loading = false;


      } catch (error) {
        console.error('Error general:', error);
        this.showSnackbar('Ocurrió un error durante el procesamiento', 'error');
        this.loading = false;
      }
    },

    processRows(rows, dbData) {
      this.processedResults = [];

      for( const i in rows ){

        const { fecha, concepto, monto, banco } = rows[i]
        // Extraer datos
        // const fecha = row[0] || '';
        // const concepto = row[1] || '';
        // const monto = row[2] || '';
        // const banco = row[3] || '';

        // Extraer la referencia del concepto
        const refExcel = this.extractReferenceFromConcept(concepto, banco);

        // Extraer información detallada del concepto
        const detailedInfo = this.extractDetailedInfoFromConcept(concepto);

        // Buscar coincidencia en la base de datos
        const matchingRecord = this.findMatchInDb(refExcel, dbData, concepto, monto);

        let tipoTransaccion;
        if (this.isEgresoTransaction(concepto, banco, monto)) {
          tipoTransaccion = 'Egreso';
        } else {
          tipoTransaccion = 'Ingreso';
        }

        // Seleccionar la primera coincidencia por defecto (la mejor según el ordenamiento)
        const firstMatch = matchingRecord && matchingRecord.length > 0 ? matchingRecord[0] : null;

        // Agregar a resultados
        this.processedResults.push({
          fecha,
          concepto,
          monto: monto ,
          banco,
          refExcel,
          tipoTransaccion,
          status: matchingRecord ? 'Con match' : 'Sin Match',
          aceptado: firstMatch && firstMatch.aceptado ? 1 : matchingRecord ? matchingRecord.aceptado : null,
          alumno: matchingRecord ? matchingRecord.alumno : null,
          dbData: firstMatch || null,
          allMatches: matchingRecord || null,  // Guardar todas las coincidencias
          currentMatchIndex: 0,
          detailedInfo: detailedInfo
        });

      }

      // rows.forEach(row => {
      //   // Asegurarnos de que la fila tiene al menos 4 columnas
      //   if (row.length < 4) return;

      //   // Extraer datos
      //   const fecha = row[0] || '';
      //   const concepto = row[1] || '';
      //   const monto = row[2] || '';
      //   const banco = row[3] || '';

      //   // Extraer la referencia del concepto
      //   const refExcel = this.extractReferenceFromConcept(concepto, banco);

      //   // Extraer información detallada del concepto
      //   const detailedInfo = this.extractDetailedInfoFromConcept(concepto);

      //   // Buscar coincidencia en la base de datos
      //   const matchingRecord = this.findMatchInDb(refExcel, dbData, concepto, monto);

      //   let tipoTransaccion;
      //   if (this.isEgresoTransaction(concepto, banco, monto)) {
      //     tipoTransaccion = 'Egreso';
      //   } else {
      //     tipoTransaccion = 'Ingreso';
      //   }

      //   // Seleccionar la primera coincidencia por defecto (la mejor según el ordenamiento)
      //   const firstMatch = matchingRecord && matchingRecord.length > 0 ? matchingRecord[0] : null;

      //   // Agregar a resultados
      //   this.processedResults.push({
      //     fecha,
      //     concepto,
      //     monto,
      //     banco,
      //     refExcel,
      //     tipoTransaccion,
      //     status: matchingRecord ? 'Encontrado' : 'Sin Match',
      //     aceptado: matchingRecord ? matchingRecord.aceptado : null,
      //     alumno: matchingRecord ? matchingRecord.alumno : null,
      //     dbData: firstMatch || null,
      //     allMatches: matchingRecord || null,  // Guardar todas las coincidencias
      //     currentMatchIndex: 0,
      //     detailedInfo: detailedInfo
      //   });
      // });
    },

    extractReferenceFromConcept(concept, banco) {
      // Patrones que NO deberían generar referencia
      if (concept.includes('DEPOSITO EN EFECTIVO')) {
        return null;
      }
      // Para BBVA (código existente)
      if (concept.includes('PAGO CUENTA DE TERCERO/')) {
        const parts = concept.split('PAGO CUENTA DE TERCERO/');
        if (parts.length > 1) {
          // Obtener la parte después del separador y eliminar espacios
          let afterSeparator = parts[1].trim();

          // Extraer solo dígitos numéricos hasta el primer espacio
          const match = afterSeparator.match(/^\s*(\d+)/);
          const refPart = match ? match[1].trim() : '';

          return refPart;
        }
      }
       // Para SPEI recibido (nuevo caso)
      else if (concept.includes('SPEI RECIBIDO')) {
        // Patrón para extraer el nombre después del segundo número
        const match = concept.match(/\d{3}\s+\d+([A-Za-z].*)/);
        if (match && match[1]) {
          // Lista de términos genéricos a excluir
          const terminosGenericos = [
            'sin informaci', 'transferencia', 'pago', 'deposito', 'abono',
            'sin datos', 'n/a', 'pendiente', 'traspaso'
          ];

          // Normalizar espacios múltiples a un solo espacio y hacer trim
          const nombreRemitente = match[1].replace(/\s+/g, ' ').trim();

          // Verificar si el nombre extraído contiene algún término genérico
          const esGenerico = terminosGenericos.some(termino =>
            nombreRemitente.toLowerCase().includes(termino.toLowerCase())
          );

          if (esGenerico) {
            return null; // No extraer nombres genéricos
          }

          return nombreRemitente;
        } else {

        }
      }
      // Para BanRegio
      else if (banco && banco.toUpperCase().includes('BR')) {
        // Caso 1: Formato con puntos (formato antiguo)
        if (concept.includes('.')) {
          // Dividir por puntos
          const parts = concept.split('.');

          // Si hay más de 5 partes, estamos probablemente ante el primer caso (números de referencia)
          if (parts.length > 5) {
            // El penúltimo elemento debería ser la referencia (como funcionaba antes)
            const refPart = parts[parts.length - 2].trim();
            return refPart;
          }
          // Si tenemos menos partes, es probable que sea el caso de Daniel Álvarez
          else if (parts.length >= 2) {
            // Tomar el último elemento como posible nombre/referencia
            const lastPart = parts[parts.length - 1].trim();
            return lastPart;
          }
        }
        // Caso 2: Formato nuevo, donde el concepto es directamente la referencia
        else {
          // Devolver el concepto completo limpio como referencia
          return concept.trim();
        }
      }
      // Para HSBC
      else if (banco && banco.toUpperCase().includes('HSBC')) {
        // Eliminar comillas si existen y devolver solo los números
        return concept.replace(/['"]/g, '').trim();
      }

      return null;
    },

    extractDetailedInfoFromConcept(concept) {
      // Eliminar prefijos comunes para limpiar el texto
      let cleanedConcept = concept.replace(/PAGO CUENTA DE TERCERO\/|SPEI RECIBIDO|SPEI\.|OVEB\d+|NB\) Recepcion de cuenta:|Recepcion de cuenta:/gi, '').trim();

      // Extraer grupos numéricos (secuencias de dígitos)
      const numericalGroups = cleanedConcept.match(/\d+/g) || [];

      // Extraer grupos de texto (palabras o frases no numéricas)
      // Primero dividimos por espacios y luego filtramos
      const words = cleanedConcept.split(/\s+/);
      const textGroups = [];
      let currentTextGroup = "";

      for (let i = 0; i < words.length; i++) {
        const word = words[i];
        // Si la palabra no es puramente numérica
        if (!/^\d+$/.test(word)) {
          if (currentTextGroup) {
            currentTextGroup += " " + word;
          } else {
            currentTextGroup = word;
          }
        } else {
          // Si encontramos un número y hay texto acumulado, guardamos el grupo
          if (currentTextGroup) {
            textGroups.push(currentTextGroup.trim());
            currentTextGroup = "";
          }
        }
      }

      // Añadir el último grupo de texto si existe
      if (currentTextGroup) {
        textGroups.push(currentTextGroup.trim());
      }

      // Filtrar grupos vacíos y eliminar duplicados
      const filteredTextGroups = [...new Set(textGroups.filter(group => group.length > 2))];

      return {
        numericalGroups: numericalGroups,
        textGroups: filteredTextGroups
      };
    },

    findMatchInDb(reference, dbData, concepto, monto) {
      if (!reference || !dbData || !dbData.length) return null;

      // Normalizar la referencia y el monto
      const normalizedRef = reference.toString().trim();
      const normalizedConcept = concepto.toString().trim();
      const montoExcel = monto ? monto : 0;

      // Array para guardar las coincidencias
      let matches = [];

      // Buscar coincidencias en aut_clave_rastreo o folio_operacion
      dbData.forEach(item => {
        // Normalizar los valores de la BD
        // const claveRastreo = item.aut_clave_rastreo ? item.aut_clave_rastreo.toString().trim() : '';
        // const folioOperacion = item.folio_operacion ? item.folio_operacion.toString().trim() : '';
        const montoBD = item.monto_pagado ? item.monto_pagado : 0;

        // Verificar diferencia de montos
        const montoDiff = Math.abs(montoExcel - montoBD);
        const hayDiferencia = montoDiff > 0.01;

        // Verificar coincidencias
        let matchType = null;

        // if (claveRastreo.toLowerCase() === normalizedRef.toLowerCase()) {
        //   matchType = 'clave_rastreo';
        // } else if (folioOperacion.toLowerCase() === normalizedRef.toLowerCase()) {
        //   matchType = 'folio_operacion';
        // } else if (item.texto_completo && item.texto_completo.toString().toLowerCase().includes(normalizedRef.toLowerCase())) {
        //   matchType = 'texto_completo';
        // }

        if (item.texto_completo && item.texto_completo.toString().toLowerCase().includes(normalizedRef.toLowerCase())) {
          matchType = 'texto_completo';
        }

        // Si hay coincidencia, añadir al array
        if (matchType) {
          // Clonar el item para no modificar el original
          const itemCopy = {...item};
          itemCopy.matchInfo = {
            referencia_extraida: normalizedRef,
            tipo_coincidencia: matchType,
            diferencia_monto: hayDiferencia ? {
              monto_excel: montoExcel,
              monto_bd: montoBD,
              diferencia: montoDiff
            } : null
          };
          matches.push(itemCopy);
        }
      });

      // Ordenar las coincidencias (primero por tipo de coincidencia, luego por diferencia de monto)
      matches.sort((a, b) => {
        // Priorizar coincidencias exactas (clave_rastreo, folio_operacion)
        const tipoA = a.matchInfo.tipo_coincidencia;
        const tipoB = b.matchInfo.tipo_coincidencia;

        if (tipoA !== tipoB) {
          if (tipoA === 'clave_rastreo') return -1;
          if (tipoB === 'clave_rastreo') return 1;
          if (tipoA === 'folio_operacion') return -1;
          if (tipoB === 'folio_operacion') return 1;
        }

        // Si los tipos son iguales, priorizar por diferencia de monto
        const diffA = a.matchInfo.diferencia_monto ? a.matchInfo.diferencia_monto.diferencia : 0;
        const diffB = b.matchInfo.diferencia_monto ? b.matchInfo.diferencia_monto.diferencia : 0;

        return diffA - diffB;
      });

      // Devolver null si no hay coincidencias, o el array de coincidencias
      return matches.length ? matches : null;
    },

    showDetails(item) {
      this.selectedItem = item;

      // Si hay múltiples coincidencias, mostrar la actualmente seleccionada
      if (item.allMatches && item.allMatches.length > 0) {
        this.selectedItem.currentMatchIndex = item.currentMatchIndex || 0;
      }

      // Inicializar búsqueda con valores relevantes
      this.detailSearch = {
        referencia: ''
      };

      this.detailSearchResults = [];
      this.detailSearchPerformed = false;
      this.detailDialog = true;
    },

    async updateStatus(item, status) {
      if (!item.dbData || !item.dbData.id_ingreso) {
        this.showSnackbar('No se puede actualizar un registro sin ID de ingreso', 'error');
        return;
      }

      const id = item.dbData.id_ingreso;

      try {
        // Mostrar indicador de carga (opcional)
        this.loading = true;

        // Llamar a la API
        const response = await axios.put(`/ingresos.rastreo.update/${id}`, {
          aceptado: status,
          comentarios: null // Puedes agregar un campo para comentarios si lo necesitas
        });

        // Actualizar el objeto localmente
        item.aceptado = status;

        // Mostrar mensaje de éxito
        this.showSnackbar(
          `Registro ${status === 1 ? 'aceptado' : 'rechazado'} correctamente`,
          'success'
        );
      } catch (error) {
        console.error('Error al actualizar el estado:', error);
        this.showSnackbar('Error al actualizar el estado del registro', 'error');
      } finally {
        this.loading = false;
      }
    },

    showManualSearch(item) {
      this.selectedItem = item;
      // Limpiar búsqueda anterior
      this.manualSearch = {
        id: '',
        alumno: '',
        monto: item.monto ? parseFloat(item.monto.replace(/,/g, '')) : '',
        referencia: item.refExcel || ''
      };
      this.manualSearchResults = [];
      this.manualSearchPerformed = false;
      this.manualSearchDialog = true;
    },

    searchRecords() {
      if (!this.dbData.length) {
        this.showSnackbar('No hay datos de la base de datos para buscar', 'error');
        return;
      }

      this.manualSearchLoading = true;
      this.manualSearchPerformed = true;

      // Convertir valores para comparación
      const searchId = this.manualSearch.id ? parseInt(this.manualSearch.id, 10) : null;
      const searchAlumno = this.manualSearch.alumno ? this.manualSearch.alumno.toLowerCase() : '';
      const searchMonto = this.manualSearch.monto ? parseFloat(this.manualSearch.monto) : null;
      const searchRef = this.manualSearch.referencia ? this.manualSearch.referencia.toString().trim() : '';

      // Filtrar registros
      const results = this.dbData.filter(item => {
        let match = true;

        // Filtrar por ID si se proporcionó
        if (searchId && item.id_ingreso !== searchId) {
          match = false;
        }

        // Filtrar por nombre de alumno si se proporcionó
        if (match && searchAlumno && !item.alumno.toLowerCase().includes(searchAlumno)) {
          match = false;
        }

        // Filtrar por monto (con margen de tolerancia del 5%)
        if (match && searchMonto) {
          const itemMonto = parseFloat(item.monto_pagado);
          const tolerance = searchMonto * 0.05; // 5% de tolerancia
          if (Math.abs(itemMonto - searchMonto) > tolerance) {
            match = false;
          }
        }

        // Filtrar por referencia
        if (match && searchRef) {
          const claveRastreo = item.aut_clave_rastreo ? item.aut_clave_rastreo.toString().trim() : '';
          const folioOperacion = item.folio_operacion ? item.folio_operacion.toString().trim() : '';

          if (!claveRastreo.includes(searchRef) && !folioOperacion.includes(searchRef)) {
            match = false;
          }
        }

        return match;
      });

      // Limitar resultados a 50 registros
      this.manualSearchResults = results.slice(0, 50);

      this.manualSearchLoading = false;
    },

    assignDbRecord(dbRecord) {
      if (!this.selectedItem) return;

      // Asignar el registro de BD al item seleccionado
      this.selectedItem.dbData = dbRecord;
      this.selectedItem.aceptado = dbRecord.aceptado;

      // Actualizar el registro en processedResults
      const index = this.processedResults.findIndex(item =>
        item.concepto === this.selectedItem.concepto &&
        item.fecha === this.selectedItem.fecha &&
        item.monto === this.selectedItem.monto
      );

      if (index !== -1) {
        this.processedResults[index].dbData = dbRecord;
        this.processedResults[index].aceptado = dbRecord.aceptado;
      }

      this.showSnackbar('Registro asignado correctamente', 'success');
      this.manualSearchDialog = false;
    },

    showSnackbar(text, color = 'info') {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },

    exportResults() {
      if (!this.processedResults.length) {
        this.showSnackbar('No hay resultados para exportar', 'warning');
        return;
      }

      try {
        // Crear una hoja de trabajo
        const worksheet = XLSX.utils.json_to_sheet(this.processedResults.map(item => ({
          Fecha: item.fecha,
          Concepto: item.concepto,
          Monto: item.monto,
          Banco: item.banco,
          'Referencia Excel': item.refExcel || '',
          Estado: item.status,
          'ID Ingreso': item.dbData ? item.dbData.id_ingreso : '',
          'Alumno': item.dbData ? item.dbData.alumno : '',
          'Clave Rastreo BD': item.dbData ? item.dbData.aut_clave_rastreo : '',
          'Folio Operacion BD': item.dbData ? item.dbData.folio_operacion : ''
        })));

        // Crear libro
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Resultados');

        // Generar archivo y descargar
        const date = new Date().toISOString().split('T')[0];
        XLSX.writeFile(workbook, `validacion_ingresos_${date}.xlsx`);

        this.showSnackbar('Archivo exportado correctamente', 'success');
      } catch (error) {
        console.error('Error al exportar:', error);
        this.showSnackbar('Error al exportar los resultados', 'error');
      }
    },

    isEgresoTransaction(concepto, banco, monto) {
      // Si no hay monto o es cero, considerarlo como egreso
      if (monto <= 0 ) {
        return true;
      }

      // Detectar conceptos que indican que no es un ingreso ABO.COMPEN
      const egresoPatterns = [
        /DEPOSITO/i,
        /SERV BCA/i,
        /SPEI ENVIADO/i,
        /ABONO/i,
        /ABO.COMPEN/i,
        /CGO SPEI/i,
        /TRANSF REC HSBCNET DEP TPV/i,
        /\(BE\) Pago servicio/i,
        /Pago servicio:/i
      ];

      return egresoPatterns.some(pattern => pattern.test(concepto));
    },

    getFullImageUrl(imageName) {
      if (!imageName) return null;

      // Si ya es una URL completa, devolverla tal cual
      if (imageName.startsWith('http')) return imageName;

      // Construir la URL completa con la base
      return `https://escuelakpi.club/comprobante-pago/${imageName}`;
    },

    navigateMatch(direction) {
      if (!this.selectedItem || !this.selectedItem.allMatches) return;

      // Calcular el nuevo índice
      const newIndex = this.selectedItem.currentMatchIndex + direction;

      // Verificar límites
      if (newIndex >= 0 && newIndex < this.selectedItem.allMatches.length) {
        // Actualizar el índice
        this.selectedItem.currentMatchIndex = newIndex;

        // Actualizar los datos mostrados
        this.selectedItem.dbData = this.selectedItem.allMatches[newIndex];
      }
    },

    selectMatch() {
      if (!this.selectedItem || !this.selectedItem.allMatches) return;

      // Obtener el registro seleccionado
      const selectedMatch = this.selectedItem.allMatches[this.selectedItem.currentMatchIndex];

      // Actualizar el registro en processedResults
      const index = this.processedResults.findIndex(item =>
        item.concepto === this.selectedItem.concepto &&
        item.fecha === this.selectedItem.fecha &&
        item.monto === this.selectedItem.monto
      );

      if (index !== -1) {
        // Guardar la coincidencia seleccionada como la principal
        this.processedResults[index].dbData = selectedMatch;
        this.processedResults[index].aceptado = selectedMatch.aceptado;
        this.processedResults[index].currentMatchIndex = this.selectedItem.currentMatchIndex;

        // Actualizar el selectedItem también
        this.selectedItem.dbData = selectedMatch;
        this.selectedItem.aceptado = selectedMatch.aceptado;

        this.showSnackbar('Coincidencia seleccionada correctamente', 'success');
      }
    },

    searchRecordsFromDetail() {
      if (!this.dbData.length) {
        this.showSnackbar('No hay datos de la base de datos para buscar', 'error');
        return;
      }

      if (!this.detailSearch.referencia.trim()) {
        this.showSnackbar('Ingrese una referencia para buscar', 'warning');
        return;
      }

      this.detailSearchLoading = true;
      this.detailSearchPerformed = true;

      // Obtener el texto de búsqueda
      const searchRef = this.detailSearch.referencia.toString().trim().toLowerCase();

      // Filtrar registros
      const results = this.dbData.filter(item => {
        // Buscar en todos los campos relevantes
        const claveRastreo = item.aut_clave_rastreo ? item.aut_clave_rastreo.toString().trim().toLowerCase() : '';
        const folioOperacion = item.folio_operacion ? item.folio_operacion.toString().trim().toLowerCase() : '';
        const textoCompleto = item.texto_completo ? item.texto_completo.toString().toLowerCase() : '';
        const alumno = item.alumno ? item.alumno.toString().toLowerCase() : '';

        return claveRastreo.includes(searchRef) ||
               folioOperacion.includes(searchRef) ||
               textoCompleto.includes(searchRef) ||
               alumno.includes(searchRef);
      });

      // Limitar resultados a 15 registros
      this.detailSearchResults = results.slice(0, 15);
      this.detailSearchLoading = false;
    },

    assignDetailResult(resultItem) {
      if (!this.selectedItem) return;

      // Crear un objeto con la info de coincidencia
      const matchedItem = {...resultItem};
      matchedItem.matchInfo = {
        referencia_extraida: this.detailSearch.referencia,
        tipo_coincidencia: 'búsqueda_manual',
        diferencia_monto: null
      };

      // Verificar si hay diferencia en montos
      if (this.selectedItem.monto) {
        const montoExcel = parseFloat(this.selectedItem.monto.replace(/,/g, ''));
        const montoBD = parseFloat(matchedItem.monto_pagado);
        const montoDiff = Math.abs(montoExcel - montoBD);

        if (montoDiff > 0.01) {
          matchedItem.matchInfo.diferencia_monto = {
            monto_excel: montoExcel,
            monto_bd: montoBD,
            diferencia: montoDiff
          };
        }
      }

      // Asignar a selectedItem
      this.selectedItem.dbData = matchedItem;
      this.selectedItem.status = 'Encontrado';

      // Si no hay coincidencias múltiples, inicializar el array
      if (!this.selectedItem.allMatches) {
        this.selectedItem.allMatches = [matchedItem];
        this.selectedItem.currentMatchIndex = 0;
      } else {
        // Verificar si ya existe esta coincidencia
        const existsIndex = this.selectedItem.allMatches.findIndex(
          m => m.id_ingreso === matchedItem.id_ingreso
        );

        if (existsIndex === -1) {
          // Agregar la nueva coincidencia al inicio
          this.selectedItem.allMatches.unshift(matchedItem);
          this.selectedItem.currentMatchIndex = 0;
        } else {
          // Seleccionar la coincidencia existente
          this.selectedItem.currentMatchIndex = existsIndex;
        }
      }

      // Actualizar el registro en la tabla principal
      const index = this.processedResults.findIndex(item =>
        item.concepto === this.selectedItem.concepto &&
        item.fecha === this.selectedItem.fecha &&
        item.monto === this.selectedItem.monto
      );

      if (index !== -1) {
        this.processedResults[index].dbData = matchedItem;
        this.processedResults[index].status = 'Encontrado';
        this.processedResults[index].allMatches = this.selectedItem.allMatches;
        this.processedResults[index].currentMatchIndex = this.selectedItem.currentMatchIndex;
      }

      this.showSnackbar('Registro asignado correctamente', 'success');

      // Limpiar resultados de búsqueda
      this.detailSearchResults = [];
      this.detailSearchPerformed = false;
    },


    getBancoColor(banco) {
      if (!banco) return 'grey';

      const bancoUpper = banco.toString().toUpperCase();
      if (bancoUpper.includes('BBVA') || bancoUpper.includes('BANCOMER')) return 'blue darken-1';
      if (bancoUpper.includes('BR') || bancoUpper.includes('BANREGIO')) return 'purple';
      if (bancoUpper.includes('SANTANDER')) return 'red darken-1';
      if (bancoUpper.includes('BANAMEX') || bancoUpper.includes('CITI')) return 'blue-grey';
      if (bancoUpper.includes('BANORTE')) return 'orange darken-1';
      if (bancoUpper.includes('HSBC')) return 'red';

      return 'green'; // Para otros bancos
    },

    getBancoLabel(banco) {
      if (!banco) return 'N/A';

      const bancoUpper = banco.toString().toUpperCase();
      if (bancoUpper.includes('BBVA') || bancoUpper.includes('BANCOMER')) return 'BBVA';
      if (bancoUpper.includes('BR') || bancoUpper.includes('BANREGIO')) return 'BanRegio';
      if (bancoUpper.includes('SANTANDER')) return 'Santander';
      if (bancoUpper.includes('BANAMEX') || bancoUpper.includes('CITI')) return 'Banamex';
      if (bancoUpper.includes('BANORTE')) return 'Banorte';
      if (bancoUpper.includes('HSBC')) return 'HSBC';

      return banco; // Para otros bancos, mostrar el valor original
    },

    saveExcel( ){

      this.cargar = true
      
      let formData = new FormData();
      // //se crea el objeto y se le agrega como un apendice el archivo
      formData.append("file", this.excelIngresos );

      console.log( this.excelIngresos )
      // /*Initialize the form data*/

      return this.$http.post('lectura.excel.ingresos', formData ).then(response=>{
        this.excelIngresos = null
        this.validarSuccess( response.data.message )
        this.getTablaIngresos( )
        this.cargar      = false
      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },

    getTablaIngresos( ){

      this.cargar = true
      
      this.archivosLeidos = []
      // /*Initialize the form data*/

      return this.$http.get('archivos.leidos.excel' ).then(response=>{
        this.archivosLeidos = response.data
        this.cargar      = false
      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })

    },

    validarMultiple( ){

      // Primero sacamos los que si concuerdas, osea... los encontrados
      let encontrados = this.processedResults.filter( el => el.status == 'Encontrado' )

      // Ahora sacamos los que no se han validado
      let sinValidar  =  encontrados.filter( el => el.aceptado != 1 )

      // Validar que haga match el monto
      // let matchMonto = sinValidar.filter( el => el.matchInfo && !el.dbData.matchInfo.diferencia_monto )

      // Ahora sacamos soloooo los que unicos, los que no hacen match con más de 1 
      this.dataMultiple = sinValidar.filter( el => el.allMatches && el.allMatches.length == 1 )

      // Abrimos el cuadro de dialogo
      this.dialgoValidaMultiple = true
        
    }
  }
};
</script>

<style scoped>
.max-width-200 {
  max-width: 200px;
}
.text-success {
  color: #4caf50 !important;
}
.text-error {
  color: #f44336 !important;
}
.text-warning {
  color: #fb8c00 !important;
}
.cursor-pointer {
  cursor: pointer;
}
.text-wrap {
  white-space: normal;
  word-break: break-word;
  display: block;
}
.concepto-container {
  font-family: monospace;
  white-space: pre-wrap;
  word-break: break-all;
  user-select: all;
  cursor: text;
}
</style>
